/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".back-button[_ngcontent-%COMP%], .delete-button[_ngcontent-%COMP%]{height:2.75rem;width:8.125rem;display:inline-block;cursor:pointer;font-size:.875rem;letter-spacing:.01rem;line-height:1.063rem}.delete-button[_ngcontent-%COMP%]{background:#9e1b32;border-radius:.125rem;border-width:0;text-align:center;color:#fff}.back-button[_ngcontent-%COMP%]{border-radius:.125rem;border:.063rem solid #00789e;color:#00789e;background:#fff;text-align:center;margin-right:1rem}"];
export { styles as styles };
